//console.log('home page script [resources/js/pages/home.js]')

$(() => {
    //$('#exampleModal').show()
})
